import {
  HamburgerMenu,
  filterByCellValueMenuItem,
  useCallbackRef,
  useJsonModal,
  useMixpanel,
  type AgGridMenuItems,
  type CareExecutionReport,
  type Column,
  type ColumnDef,
  type FilterableProperty,
  type UseFilterBuilderOutput,
} from '@talos/kyoko';
import type { GetContextMenuItemsParams } from 'ag-grid-community';
import { useMemo, type ReactNode } from 'react';
import { colIDToFilterBuilderKey } from './useCareExecutionReportsFilter';

export function useCareExecutionReportsMenu({
  openClause,
  filterableProperties,
}: {
  openClause: UseFilterBuilderOutput['addAndOpenClause'];
  filterableProperties: FilterableProperty<string>[];
}): {
  columns: Column[];
  getCustomContextMenuItems: (params: GetContextMenuItemsParams<CareExecutionReport>) => AgGridMenuItems;
  dialogs: ReactNode;
} {
  const mixpanel = useMixpanel();
  const { handleClickJson, jsonModal } = useJsonModal();

  const getCustomContextMenuItems = useCallbackRef((params: GetContextMenuItemsParams<CareExecutionReport>) => {
    return filterByCellValueMenuItem({ params, filterableProperties, openClause, colIDToFilterBuilderKey, mixpanel });
  });

  const dialogs = useMemo(() => <>{jsonModal}</>, [jsonModal]);

  const columns = useMemo(
    () =>
      [
        {
          type: 'hamburgerMenu',
          id: 'rowMenu',
          params: {
            renderItems: params => <HamburgerMenu {...params} onShowJson={handleClickJson} />,
          },
        },
      ] satisfies ColumnDef<CareExecutionReport>[],
    [handleClickJson]
  );

  return {
    columns,
    getCustomContextMenuItems,
    dialogs,
  };
}
